import { Component } from '@angular/core';
import { ViewController, NavParams, ToastController } from 'ionic-angular';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';

/**
 * Generated class for the CoLoginComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-staff-pin',
  templateUrl: 'co-staff-pin.html'
})
export class CoStaffPinComponent {

  staffPin: string;
  submitText: string;

  constructor(private navParams: NavParams, private viewCtrl: ViewController, private toast: ToastAlertsProvider) {
    this.staffPin = "";
    this.submitText = this.navParams.data.submitText || 'Submit';
  }

  dismiss(hasPin: boolean) {
    if(hasPin && this.staffPin.length > 0) this.viewCtrl.dismiss(this.staffPin);
    else if(hasPin) this.toast.showAlert('', 'Please provide a PIN.', 'warning', 5000);
    else this.viewCtrl.dismiss(false);
  }

}



// WEBPACK FOOTER //
// ./src/components/co-staff-pin/co-staff-pin.ts